/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkCreateFileNodesRequest } from '../../models/bulk-create-file-nodes-request';
import { FileNodeDto } from '../../models/file-node-dto';

export interface BulkCreateFileNodes$Params {
      body: BulkCreateFileNodesRequest
}

export function bulkCreateFileNodes(http: HttpClient, rootUrl: string, params: BulkCreateFileNodes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FileNodeDto>>> {
  const rb = new RequestBuilder(rootUrl, bulkCreateFileNodes.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FileNodeDto>>;
    })
  );
}

bulkCreateFileNodes.PATH = '/v0/fileSystem/bulk';
